import { ContentType } from '@entries/content-types'
import ContentfulBlogArticleButton from '@entries/contentful-blog-article-button'
import ContentfulBlogAuthorButton from '@entries/contentful-blog-author-button'
import ContentfulBlogTagButton from '@entries/contentful-blog-tag-button'
import ContentfulDeprecatedPageButton from '@entries/contentful-deprecated-page-button'
import ContentfulStaticPageButton from '@entries/contentful-static-page-button'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulInternalLinkButton: Utils.EntryFC<
  Queries.ContentfulInternalLinkButtonFragment
> = ({ content: { label, pageRef } }) => (
  <Entry
    content={pageRef}
    mapping={{
      [ContentType.ContentfulBlogArticle]: ContentfulBlogArticleButton,
      [ContentType.ContentfulBlogAuthor]: ContentfulBlogAuthorButton,
      [ContentType.ContentfulBlogTag]: ContentfulBlogTagButton,
      [ContentType.ContentfulDeprecatedPage]: ContentfulDeprecatedPageButton,
      [ContentType.ContentfulStaticPage]: ContentfulStaticPageButton,
    }}
  >
    {label}
  </Entry>
)

export const query = graphql`
  fragment ContentfulInternalLinkButton on ContentfulInternalLink {
    ...ContentfulEntry
    label
    pageRef {
      ...ContentfulBlogArticleButton
      ...ContentfulBlogAuthorButton
      ...ContentfulBlogTagButton
      ...ContentfulDeprecatedPageButton
      ...ContentfulStaticPageButton
    }
  }
`

export default withDisplayName(
  ContentfulInternalLinkButton,
  'ContentfulInternalLinkButton'
)
